let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gTShp")).then(() => parcelRequire('7p86r'));